"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformDiscountToString = transformDiscountToString;
const transformCurrencyToString_1 = require("./transformCurrencyToString");
function transformDiscountToString(discount, pricingCurrency) {
    return `${(0, transformCurrencyToString_1.transformCurrencyToString)(pricingCurrency)}${discount.price}, fee: ${(0, transformCurrencyToString_1.transformCurrencyToString)(pricingCurrency)}${discount.fee}`;
}
//# sourceMappingURL=transformDiscountToString.js.map